import { connect } from 'react-redux'
import { UpdateStates as UpdateGlobalStates } from '#/store/actions/global'
import { SetMapOption } from '#/store/actions/preferences'
import { GetMlsInfo } from '#/store/actions/properties'
import * as Actions from '#/store/actions/property'
import { AddRecentView, UpdateStates, GetShareLink } from '#/store/actions/user'
import { currentRoleWithShared } from '#/store/selectors/user'
import PropertyDetail from './PropertyDetail'

export { getServerSideProps } from './getServerSideProps'

const mapStateToProps = (state: TopHap.StoreState) => ({
  asyncStatus: state.global.status,
  authenticated: state.user.info.isAnonymous === false,
  currentRole: currentRoleWithShared(state),
  data: state.property,
  isMobile: state.global.isMobile.any,
  mls: state.properties.mls,
  fromList: state.ui.sider.properties.fromList,
  viewportWidth: state.ui.viewport.width,
  isGuest: !!state.user.paymentInfo?.ownerId,
  agentInfo: state.user.agentInfo || state.user.linkBrandedAgentInfo
})

const mapDispatchToProps = {
  addRecentView: AddRecentView,
  clearShareRole: () => UpdateStates({ sharedRole: undefined }),
  getMlsInfo: GetMlsInfo,
  getShareLink: GetShareLink,
  setMapOption: SetMapOption,
  setPropertyDetails: Actions.SetPropertyDetails,
  getHistory: Actions.GetHistory,
  getOwnerInfo: Actions.GetOwnerInfo,
  getPublicRecord: Actions.GetPublicRecord,
  // getPrediction: Actions.GetPrediction,
  // getEstimateHistory: Actions.GetEstimateHistory,
  // getRentEstimateHistory: Actions.GetRentEstimateHistory,
  getMarketChanges: Actions.GetMarketChanges,
  // getMarketHistory: Actions.GetMarketHistory,
  // getInsightsData: Actions.GetInsightsData,
  // getSchoolDetails: Actions.GetSchoolDetails,
  // getComparables: Actions.GetComparables,
  // getNearbyStatistics: Actions.GetNearbyStatistics,
  setIsReferrerGoogle: (isReferrerGoogle?: boolean) => UpdateGlobalStates({ isReferrerGoogle })
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyDetail)
